// @ts-nocheck
import { plugin } from './plugin';
import * as Plugin_0 from '../../app.ts';
import * as Plugin_1 from '/tmp/build/src/node_modules/@onejs/plugin-lx/lib/lxapp.js';
import * as Plugin_2 from '/tmp/build/src/packages/onejsProject/src/.umi-production/plugin-mobx/runtime';
import * as Plugin_3 from '/tmp/build/src/node_modules/@onejs/plugin-cat/lib/catRuntime.js';
import * as Plugin_4 from '/tmp/build/src/packages/onejsProject/src/.umi-production/plugin-cat/runtime_cat.js';

  plugin.register({
    apply: Plugin_0,
    path: '../../app.ts',
  });
  plugin.register({
    apply: Plugin_1,
    path: '/tmp/build/src/node_modules/@onejs/plugin-lx/lib/lxapp.js',
  });
  plugin.register({
    apply: Plugin_2,
    path: '/tmp/build/src/packages/onejsProject/src/.umi-production/plugin-mobx/runtime',
  });
  plugin.register({
    apply: Plugin_3,
    path: '/tmp/build/src/node_modules/@onejs/plugin-cat/lib/catRuntime.js',
  });
  plugin.register({
    apply: Plugin_4,
    path: '/tmp/build/src/packages/onejsProject/src/.umi-production/plugin-cat/runtime_cat.js',
  });

export const __mfsu = 1;
